import React, { Component } from 'react'
import { connect } from 'react-redux'

import '../../../v2SPRINTA/style.css'

import Display from '../../../v2SPRINTA/atoms/Display'
import { Col, Row, Container, FluidContainer } from '../../../v2SPRINTA/atoms/Grid'

import { Redirect } from 'react-router-dom'
import LoadingPage from '../../../v2SPRINTA/molecules/LoadingPage'
import Button from '../../../v2SPRINTA/atoms/Button'
import { experienceFind } from '../CreateExperience/_utils'
import CoverImage from '../../../SPRINTA/atoms/CoverImage'
import FontIcon from '../../../SPRINTA/atoms/FontIcon'
import SocialShare from '../../../SPRINTA/atoms/SocialShare'
import css from './style.module.css'
class ExperienceFinished extends Component {

    state = {
        loading: true,
        data: null
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    constructor(props) {
        super(props)
        
        experienceFind(props.match.params.token)
        .then(resp => {
            
            if(resp.errors && resp.errors.length) {
                this.setState({
                    loading: false
                })
                return
            }

            this.setState({
                token: props.match.params.token,
                loading: false,
                data: resp
            })
        })
    }

    render() {

        if(this.state.loading) 
        return <LoadingPage />

        if(!this.state.data || this.state.data.experience.status !== 4)
        return <Redirect to='/create/experience' />

        return (
            <div>
                <FluidContainer>
                    <Row>
                        <CoverImage
                                image={this.state.data.cover ? this.state.data.cover.url : null}
                                shadow='300'
                                style={{ backgroundColor: '#333', color: '#fff' }}>
                                <Container>
                                    <Row alignItems='center' justifyContent="center"  style={{ paddingTop: '100px' }}>
                                        <Col size='12 12 11' text='center' style={{ marginBottom: '80px' }}>
                                            <Display heading size={1}>Sua experiência está <b>publicada!</b></Display>
                                            <br />

                                            <Display size={2}>
                                                Agora é hora de divulgar ela e conferir
                                                <br /> se o pessoal está se inscrevendo
                                            </Display>
                                            <br />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col size='12' text='center' style={{ marginBottom: '60px' }}>
                                            <b>{this.state.data.experience.title}</b> <br />
                                            {this.state.data.experience.city} ({this.state.data.experience.state})
                                        </Col>
                                    </Row>
                                </Container>
                        </CoverImage>
                    </Row>
                </FluidContainer>
                <Container>
                    <Row style={{ paddingTop: '60px' }}>
                        <Col
                            size='12 12 4'
                            text='center'
                            style={{ marginBottom: '60px' }}
                            className={css.box}>
                            <div>
                                <p>
                                    <FontIcon name='admin_notification' size={50} color='#f50' />
                                </p>
                                <p>
                                    <Display size={2}><b>Divulgue</b> sua <br /> experiência</Display>
                                </p>
                                <p>
                                    Agora é a hora de sair gritando para o mundo que sua experiência existe! Não economize suas forças e palavras, divulgue o máximo possível
                                </p>
                            </div>
                            <div style={{ marginTop: '30px' }}>
                                <SocialShare type='Facebook' href={`https://app.sprinta.com.br/experience/${this.state.data.experience.token}`}>
                                    <FontIcon name='facebook' size={35} color='#f50' />
                                </SocialShare>
                                <SocialShare type='Twitter' href={`https://app.sprinta.com.br/experience/${this.state.data.experience.token}`}>
                                    <FontIcon name='twitter'  size={35} color='#f50' style={{ marginLeft: '10px' }} />
                                </SocialShare>
                            </div>
                        </Col>
                        <Col
                            size='12 12 4'
                            text='center'
                            style={{ marginBottom: '60px' }}
                            className={css.box}>
                            <div>
                                <p>
                                    <FontIcon name='sprinta-group' size={50} color='#f50' />
                                </p>
                                <p>
                                    <Display size={2}><b>Visite</b> a página <br /> da experiência</Display>
                                </p>
                                <p>
                                    Confira a página da sua <br/> experiência recém criada
                                </p>
                            </div>
                            <div style={{ marginTop: '30px' }}>
                                <a href={`https://app.sprinta.com.br/experience/${this.state.data.experience.token}`}>
                                    <Button inline primary>Visitar página</Button>
                                </a>
                            </div>
                        </Col>
                        <Col
                            size='12 12 4'
                            text='center'
                            style={{ marginBottom: '60px' }}
                            className={css.box}>
                            <div>
                                <p>
                                    <FontIcon name='event_config' size={50} color='#f50' />
                                </p>
                                <p>
                                    <Display size={2}><b>Gerencia</b> a sua <br /> experiência</Display>
                                </p>
                                <p>
                                    Acesse o painel de controle da sua experiência e confira a lista de inscritos, o faturamento e atualize alguns dados, conforme a necessidade
                                </p>
                            </div>
                            <div style={{ marginTop: '30px' }}>
                                <a href={`https://www.sprinta.com.br/dash`}>
                                    <Button inline primary>Acessar painel de controle</Button>
                                </a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    user: store.user
})
const mapDispatchToProps = {
}
export default connect( mapStateToProps, mapDispatchToProps )(ExperienceFinished)


// WEBPACK FOOTER //
// ./src/App/pages/ExperienceFinished/index.js